// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"521":"30704546","580":"4e843b1a","617":"ffbc2ba2"}[chunkId] + ".chunk.js";
};